import { useRouter } from "next/router";
import useSWR from "swr";
import { fetcher } from "../../../common/hooks";
import { Mode } from "../models/mode.model";

export const useModes = ({
    companyId,
    locationId,
}: {
    companyId?: string;
    locationId?: string;
}) => {
    const { locale } = useRouter();

    const getAPI = () => {
        if (!companyId) {
            return null;
        }
        if (!locationId) {
            return `/api/rule-management/v1/companies/${companyId}/modes`;
        }
        return `/api/rule-management/v1/companies/${companyId}/locations/${locationId}/modes`;
    };
    const url = getAPI();
    const { data, isLoading, mutate } = useSWR(
        url ? [url, locale] : null,
        ([swrUrl]) => fetcher(swrUrl),
        {
            fallbackData: [],
        }
    );

    return {
        modes: data as Mode[],
        isLoadingModes: isLoading,
        mutateModes: mutate,
    };
};
